import { render, staticRenderFns } from "./PersonalConfigZ32S.vue?vue&type=template&id=20cd2fc0&scoped=true&"
import script from "./PersonalConfigZ32S.vue?vue&type=script&lang=js&"
export * from "./PersonalConfigZ32S.vue?vue&type=script&lang=js&"
import style0 from "./PersonalConfigZ32S.vue?vue&type=style&index=0&id=20cd2fc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd2fc0",
  null
  
)

component.options.__file = "PersonalConfigZ32S.vue"
export default component.exports